var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrowMobile = function SvgRightArrowMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E5EBEE",
    strokeWidth: 1.5,
    d: "M29.25 15c0 7.87-6.38 14.25-14.25 14.25S.75 22.87.75 15 7.13.75 15 .75 29.25 7.13 29.25 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0265dc",
    strokeWidth: 3,
    d: "m16.03 10.787 4.314 4.314-4.314 4.314M9.101 15.101h11.331"
  })));
};
export { SvgRightArrowMobile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI5LjI1IDE1QzI5LjI1IDIyLjg3MDEgMjIuODcwMSAyOS4yNSAxNSAyOS4yNUM3LjEyOTk0IDI5LjI1IDAuNzQ5OTk2IDIyLjg3MDEgMC43NDk5OTcgMTVDMC43NDk5OTkgNy4xMjk5NCA3LjEyOTk0IDAuNzUwMDAxIDE1IDAuNzUwMDAzQzIyLjg3MDEgMC43NTAwMDQgMjkuMjUgNy4xMjk5NSAyOS4yNSAxNVoiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNFNUVCRUUiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xNi4wMzAxIDEwLjc4NjhMMjAuMzQ0MyAxNS4xMDExTDE2LjAzMDEgMTkuNDE1MyIgc3Ryb2tlPSIjMDI2NWRjIiBzdHJva2Utd2lkdGg9IjMiLz4KPHBhdGggZD0iTTkuMTAxMDcgMTUuMTAxMUwyMC40MzIgMTUuMTAxMSIgc3Ryb2tlPSIjMDI2NWRjIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==";